
import { defineComponent } from "vue";

export default defineComponent({
  props: { value: String, type: String },
});
